import { Dialog, DialogFooter, DialogType } from "@fluentui/react/lib/Dialog";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { common } from "../messages/common-items";
const { Labels: Lbl_Common } = common;

interface CustomDialogProps {
  hidden: boolean;
  title: string;
  message?: string;
  onClose: () => void;
  buttonText?: string;
}

export const CustomDialog: React.FC<CustomDialogProps> = ({
  hidden,
  title,
  message,
  onClose,
  buttonText
}) => {
  return (
    <Dialog
      hidden={hidden}
      dialogContentProps={{
        type: DialogType.normal,
        title: title,
        subText: message,
        showCloseButton: false,
      }}
      modalProps={{
        isBlocking: true,
      }}
    >
      <DialogFooter>
        <PrimaryButton
          className="custom-primary-button"
          text={Lbl_Common.UNDERSTOOD_BUTTON}
          onClick={onClose}
        />
      </DialogFooter>
    </Dialog>
  );
};